import { RECORD_COPY } from '../../business-functions/records/constants/recordCopy';

export const RECORD_PERMISSION_COPY = {
  panelTitle: 'Record permissions',
  recordAccessSection: 'Record access',
  rowActionsSection: 'Row actions',
  disabledHelper: 'Enable service View to configure record permissions',
  inheritBadge: 'Defaults from service access',
  customBadge: 'Custom record permissions',
  resetToDefaults: 'Reset to defaults',
  whatsappWarning: 'Also enable WhatsApp → Send template in General permissions',
  presets: {
    readOnly: 'Read only',
    agent: 'Agent',
    manager: 'Manager',
  },
  crud: {
    view: 'View',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    download: 'Download',
    import: 'Import',
    move: 'Move to',
  },
  rowActions: {
    assign: RECORD_COPY.rowActions.assignLead,
    statusLogs: RECORD_COPY.rowActions.statusLogs,
    sendTemplate: RECORD_COPY.rowActions.sendTemplate,
    images: RECORD_COPY.rowActions.images,
    quickCall: RECORD_COPY.rowActions.quickCall,
    chat: RECORD_COPY.rowActions.chat,
    manageRecord: RECORD_COPY.rowActions.manageRecord,
    addComment: RECORD_COPY.rowActions.addComment,
  },
};
